// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class IsHcpIntakeAllowedResponseModel {
    'isIntakeAllowed': boolean;
    'reasonsNotAllowed': Array<string>;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof IsHcpIntakeAllowedResponseModel>> = [
        {
            "name":     "isIntakeAllowed",
            "baseName": "isIntakeAllowed",
            "type":     "boolean"
        },
        {
            "name":     "reasonsNotAllowed",
            "baseName": "reasonsNotAllowed",
            "type":     "Array<string>"
        },
    ];

    static getAttributeTypeMap() {
        return IsHcpIntakeAllowedResponseModel.attributeTypeMap;
    }
}
